import React, { useEffect, useState, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
  useTheme,
  FormControl,
  FormHelperText,
  Fab,
  IconButton,
} from '@material-ui/core';
import { Table } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import { useLocation, history } from 'umi';
import dayjs from 'dayjs';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from '@material-ui/icons/Add';
import DateRangePickerML from '@/components/DateRangePickerML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ModalML from '@/components/ModalML/NewModalML';
import CouponModal from './components/operate_modal/coupon_modal/index';
import { OPT_DETAIL } from '@/constants';
import { TextFieldCom } from '@/components/FormType';
import TitleML from './components/TitleML';
import request from '@/utils/request';
import Styled from './indexStyles';

export default () => {
  const theme = useTheme();
  const location = useLocation();
  const { query } = location;
  const { id, opt } = query;
  const saveRef = useRef();
  const { handleSubmit, control, setValue, getValues, errors } = useForm({
    defaultValues: {},
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [openDialog, setOpenDialog] = useState();
  const [ticketList, setTicketList] = useState([]);
  const [dialogStatus, setDialogStatus] = useState(false);
  const handleSubmitSuccess = (data) => {
    console.log(data);
    const params = {
      taskName: data.taskName,
      beginTime: dayjs(data.date.startDate).format('YYYY-MM-DD 00:00:00'),
      endTime: dayjs(data.date.endDate).format('YYYY-MM-DD 23:59:59'),
      detailList: ticketList.map((item) => ({
        couponId: item.id,
        issueQuantity: data[item.id],
      })),
    };
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    const url = '/coupon/issueTask/add';
    request(url, {
      method: 'POST',
      data: params,
    })
      .then((res) => {
        if (res?.code === 0) {
          window.message.toast({
            type: 'success',
            message: id ? '更新成功' : '新建成功',
            title: '成功',
          });
          setTimeout(() => {
            history.goBack();
          }, 2000);
        }
      })
      .finally(() => {
        setIsSubmit(false);
      });
  };
  const handleSubmitFail = () => {
    setIsSubmit(false);
  };

  useEffect(() => {
    const initData = async () => {
      if (id) {
        // const detail = await request('/line/queryTempDetail', {
        //   method: 'POST',
        //   data: {
        //     id,
        //   },
        // });
      }
    };
    initData();
  }, [id]);

  //关于退出
  const handleExitClick = () => {
    if (opt !== OPT_DETAIL) {
      setOpenDialog(true);
    } else {
      history.goBack();
    }
  };

  const columns = [
    {
      title: '优惠券ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '优惠券名称',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '库存',
      dataIndex: 'surplus',
      key: 'surplus',
    },
    {
      title: '类型',
      key: 'typeName',
      dataIndex: 'typeName',
      render: (_, record) => {
        return record.typeName === 'CASH_COUPON' ? '满减券' : '免票券';
      },
    },
    {
      title: '发放数量',
      key: 'ticket',
      dataIndex: 'ticket',
      render: (_, record) => (
        <Box display="flex" alignItems="center" gap="0 3px">
          <SvgIconML
            name="coupon"
            className="coupon"
            size={18}
            fill={theme.palette.primary.main}
          ></SvgIconML>
          <TextFieldCom
            style={{ width: '100px' }}
            showLabel={false}
            control={control}
            label="发放数量"
            isNumber={true}
            isPositiveNumber={true}
            isParseInt={true}
            name={String(record.id)}
            getValues={getValues}
            setValue={setValue}
            errors={errors}
            rules={{ min: 0, max: record.surplus }}
            defaultValue={1}
            endAdornment={
              <Box color="#000" fontSize="14px">
                张
              </Box>
            }
          />
        </Box>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <IconButton aria-label="delete">
          <SvgIconML
            name="circleDelete"
            size={22}
            fill={theme.palette.primary.main}
            className="preview"
            onClick={() => {
              handleDeleteTicket(record.id);
            }}
          />
        </IconButton>
      ),
    },
  ];

  const handleDeleteTicket = (tId) => {
    setTicketList(ticketList.filter((item) => item.id !== tId));
  };
  const handleClickAdd = () => {
    setDialogStatus(true);
  };

  const handleAddTicket = (selectList) => {
    console.log(selectList);
    setDialogStatus(false);
    setTicketList(selectList);
  };

  const handleCancel = () => {
    setDialogStatus(false);
  };
  return (
    <Styled theme={theme}>
      <Box>
        <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
          <Box
            borderRadius="12px"
            bgcolor="background.paper"
            p={[3, 4]}
            display="flex"
            flexDirection="column"
            gap="0 24px"
          >
            <TitleML title="基本设置" fontSize="19px" />
            <Box className="coupons-setting-box-4fr">
              <TextFieldCom
                control={control}
                label="任务名称"
                name="taskName"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                rules={{ required: true, maxLength: 15 }}
              />
            </Box>

            <Box mt={5} mb={4}>
              <Box fontSize="14px" color="#666" mb={1}>
                <span style={{ color: 'red' }}>*</span>
                领取时间
              </Box>
              <Box className="coupons-setting-box-2fr">
                <FormControl variant="standard">
                  <Controller
                    render={(rp) => (
                      <DateRangePickerML
                        startText="开始时间"
                        endText="结束时间"
                        defaultStartDate={rp?.value?.startDate}
                        defaultEndDate={rp?.value?.endDate}
                        rp={rp}
                        setValue={setValue}
                        name="custom-form-submit-name"
                        disabled={opt === OPT_DETAIL}
                      />
                    )}
                    name="date"
                    control={control}
                    rules={{
                      validate: () => {
                        const status = !(
                          !getValues('date') ||
                          getValues('date')?.startDate === null ||
                          getValues('date')?.endDate === null
                        );
                        return status;
                      },
                    }}
                  />
                  {Boolean(errors?.date) && (
                    <FormHelperText
                      error={Boolean(errors?.date)}
                      style={{ fontSize: '12px' }}
                    >
                      领取时间是必选项
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Box>
            <TitleML title="发放优惠券" fontSize="19px" />
            <Box mb={5}>
              <Box mb={2}>
                <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  className="export"
                  sx={{ marginRight: '16px' }}
                  onClick={handleClickAdd}
                >
                  <AddIcon sx={{ width: '24px', height: '24px' }} />
                  添加
                </Fab>
              </Box>
              <Table
                columns={columns}
                dataSource={ticketList}
                size="small"
                pagination={false}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            gap="0 16px"
            borderRadius="12px"
            bgcolor="background.paper"
            p={[3, 4]}
            mt={1.5}
          >
            {opt !== OPT_DETAIL && (
              <Button
                ref={saveRef}
                variant="contained"
                className="coupons-setting-button"
                type="submit"
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
              >
                完成
              </Button>
            )}
            <Button
              variant="contained"
              className="coupons-setting-button"
              color="secondary"
              onClick={handleExitClick}
              startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
            >
              退出
            </Button>
          </Box>
        </form>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {opt !== OPT_DETAIL ? '退出后将不保存设置内容，确定要退出吗？' : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>

      <ModalML
        open={dialogStatus}
        setOpen={setDialogStatus}
        onCancel={handleCancel}
        title="选择优惠券"
        onConfirm={handleAddTicket}
        onClose={handleCancel}
      >
        <CouponModal
          open={dialogStatus}
          control={control}
          setOpen={setDialogStatus}
          onConfirm={handleAddTicket}
          couponList={ticketList}
        ></CouponModal>
      </ModalML>
    </Styled>
  );
};
